<template>
  <div>
    <v-data-table :headers="headersLocations" :items="getLocations" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Статусы работы по локациям</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" dark class="mb-2" @click="clickAddContact"> Добавить </v-btn> -->
        </v-toolbar>
      </template>


<!--      <template v-slot:[`item.actions`]="{ item }">-->
<!--        <v-icon small class="mr-2" @click="editItemContact(item)"> mdi-pencil </v-icon>-->
<!--        <v-icon small @click="deleteItemContact(item)"> mdi-delete </v-icon>-->
<!--      </template>-->
    </v-data-table>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="pink" dark bottom right fab fixed @click="addNewLocation" v-bind="attrs" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </template>
      <span>Добавить заявку</span>
    </v-tooltip>


  </div>
</template>

<script>

import { mapGetters } from "vuex"
// import { eventBus } from "@/main"

// import DialogInfo from "@/components/dialogs/DialogInfo"


export default {
  name: "LocationsPage",
  components: {
    //DialogInfo
  },

  data() {
    return {
      Locations:[],
      headersLocations: [
        { text: "Филиал", value: "location" },
        { text: "Объем хранения", value: "storageCapacity" },
        { text: "Объем переработки", value: "processingVolume" },
        { text: "Способ переработки", value: "processing_method" },
        { text: "Ассортимент", value: "assortment" },
        { text: "Дата начала операций", value: "startOperation" },
        { text: "Статус", value: "status" },
        { text: "Контактное лицо склада", value: "contactStore" },
        { text: "Контактное лицо филиала", value: "contactLocation" },
        { text: "", value: "actions", sortable: false },
      ],

    }
  },
  methods: {
    addNewLocation(){
      //Добавляем новую локацию со статусом черновик
      //В самих локациях храним храним журнал заявок на изменение условий
      //Заявку на изменение условий работы передаем в виде json файла
      console.log('fab')
    },
    // ...mapActions(["apiExecutecommand"]),

  },
  watch: {},
  computed: {
    ...mapGetters('app',["getLocations"])
  },
  created() {
  },
}
</script>
